import { getEndDate, getSessionLink, getStartDate, SessionState } from "@kvix/shared";
import { format } from "date-fns";
import React from "react";
import { CardBase } from "./partials/CardBase";
export const SessionListCard = (props) => {
    const { article, user, state } = props;
    const start = getStartDate(article);
    const end = getEndDate(article);
    const startTime = format(start, "HH:mm");
    const now = new Date();
    const isLive = state === SessionState.Running;
    const isFinished = state === SessionState.Finished;
    const isStarting = !isLive && !isFinished && now >= start && now < end;
    const isCancelled = state === SessionState.Cancelled;
    const link = getSessionLink(article, user);
    return (React.createElement(CardBase, { imageUrl: article.imageUrl, instructorName: article.instructorName, rating: article.rating, title: article.title, duration: article.duration, level: article.level, equipment: article.equipment, filterByChip: props.filterByChip, link: link, isLiked: props.isLiked, goesLiveAt: startTime, isLive: isLive, isCancelled: isCancelled, isStarting: isStarting, bookedUsersSummary: article.bookedUsersSummary, start: start }));
};
//# sourceMappingURL=UpcomingSessionListCard.js.map